import qrGenerator from 'qrcode-generator';

function utf16to8(str: string): string {
  let out = '';
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007f) {
      out += str.charAt(i);
    } else if (c > 0x07ff) {
      out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    } else {
      out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    }
  }
  return out;
}

/**
 * Generate a QR code as a base64 data URL.
 * Adapted from the old app's QRCode.service.ts.
 */
export function getBase64QRCode(
  value: string = 'Valet Manager',
  ecLevel: 'L' | 'M' | 'Q' | 'H' = 'M',
  size: number = 150,
  quietZone: number = 10,
  bgColor: string = '#FFFFFF',
  fgColor: string = '#000000'
): string {
  const canvas = document.createElement('canvas');
  const qrCode = qrGenerator(0, ecLevel);
  qrCode.addData(utf16to8(value));
  qrCode.make();

  const ctx = canvas.getContext('2d')!;
  const canvasSize = size + 2 * quietZone;
  const length = qrCode.getModuleCount();
  const cellSize = size / length;
  const scale = window.devicePixelRatio || 1;

  canvas.height = canvasSize * scale;
  canvas.width = canvasSize * scale;
  ctx.scale(scale, scale);

  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, canvasSize, canvasSize);

  const offset = quietZone;

  ctx.fillStyle = fgColor;
  for (let row = 0; row < length; row++) {
    for (let col = 0; col < length; col++) {
      if (qrCode.isDark(row, col)) {
        const w = Math.ceil((col + 1) * cellSize) - Math.floor(col * cellSize);
        const h = Math.ceil((row + 1) * cellSize) - Math.floor(row * cellSize);
        ctx.fillRect(
          Math.round(col * cellSize) + offset,
          Math.round(row * cellSize) + offset,
          w,
          h
        );
      }
    }
  }

  return canvas.toDataURL();
}
